import { apiClient } from './apiClient';

export interface RelanceMinimumAmountSettingResponse {
    minimumAmount: number;
}

// Every save still running, ranking included; overlapping saves are chained so readers wait for all of them.
let inFlight: Promise<unknown> = Promise.resolve();

export const relanceMinimumAmountService = {
    get: (): Promise<RelanceMinimumAmountSettingResponse> =>
        apiClient.get<RelanceMinimumAmountSettingResponse>('/company-settings/relance-minimum-amount'),

    set: (minimumAmount: number, noAi = false): Promise<void> => {
        const put = apiClient.put<void>(`/company-settings/relance-minimum-amount${noAi ? '?noAi=true' : ''}`, { minimumAmount });
        inFlight = Promise.allSettled([inFlight, put]);
        return put;
    },

    /** Resolves once every save has finished, whether it succeeded or failed. */
    settled: (): Promise<unknown> => inFlight,
};
